import { ApolloProvider } from '@apollo/client';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import Honeybadger from '@honeybadger-io/js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';

import 'normalize.css';
import * as redux from './kb-redux';
import reduxStore from './kb-redux/store';
import { logDeploymentInfo } from 'config';
import { FeatureFlagsProvider } from 'hooks/useFeatureFlags/FeatureFlagsProvider';
import { configure, graphql, utils } from 'kb-shared';
import { theme } from 'kb-shared';
import { filterHoneybadgerNotices, honeyBadgerConfig } from 'kb-shared/utilities/bugTracker.helper';
import { ErrorCatcher } from 'layouts/errorCatcher/ErrorCatcher';
import { ThemeProvider } from 'styled-components';
import { suppressApolloDeprecationWarnings } from 'utilities/apolloDeprecations';

import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

import './index.css';
import 'react-image-crop/dist/ReactCrop.css';

declare global {
  interface Window {
    __removeFallback: () => void;
  }
}

suppressApolloDeprecationWarnings();

if (window.__removeFallback) window.__removeFallback();

const { setClearPwLocalStorage } = utils;

const appLoaded = redux.patient.appLoaded;

// Turn on hot-reloading
// @ts-ignore
// module.hot && module.hot.accept();

// Configure kb-shared
Honeybadger.configure(honeyBadgerConfig);
Honeybadger.beforeNotify(filterHoneybadgerNotices);
configure({ bugTracker: Honeybadger });

// Configure ApolloClient
const client = graphql.client;

// Platform specific config for web
setClearPwLocalStorage(() => localStorage.removeItem('kindbody-auth-password'));

// Initial load of user into Redux
// @ts-ignore
reduxStore.dispatch(appLoaded());

logDeploymentInfo();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ReduxProvider store={reduxStore}>
    <ApolloProvider client={client}>
      <FeatureFlagsProvider>
        <ThemeProvider theme={theme}>
          <HelmetProvider>
            <ErrorCatcher id="app">
              <App />
            </ErrorCatcher>
          </HelmetProvider>
        </ThemeProvider>
      </FeatureFlagsProvider>
    </ApolloProvider>
  </ReduxProvider>
);

// Turn off Service Worker
unregisterServiceWorker();
